import { render } from "./ProductVariationListComponent.vue?vue&type=template&id=bf9ffb02"
import script from "./ProductVariationListComponent.vue?vue&type=script&lang=js"
export * from "./ProductVariationListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/products/variation/ProductVariationListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf9ffb02"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf9ffb02', __exports__)) {
    api.reload('bf9ffb02', __exports__)
  }
  
  module.hot.accept("./ProductVariationListComponent.vue?vue&type=template&id=bf9ffb02", () => {
    api.rerender('bf9ffb02', render)
  })

}


export default __exports__